import { connect } from 'react-redux'
import {
  compose,
  pure,
  withStateHandlers,
  withHandlers,
  lifecycle,
} from 'recompose'
import Router from 'next/router'

import { withI18next } from '../../lib/withI18next'
import { notify } from '../../lib/notification'
import { logOut, terminateRemoteSessions } from '../../reducers/user'
import { getCSRF } from '../../reducers/global'
import AppWrapper from './AppWrapper'

const mapStateToProps = state => {
  return {
    user: state.user.details || {},
    isAuthenticated: state.user.isAuthenticated,
    hasRemoteSessions: state.user.hasRemoteSessions,
    language: state.cookies.lang,
    cart: state.cart
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logOut: () => dispatch(logOut()),
    terminateRemoteSessions: () => dispatch(terminateRemoteSessions()),
    createNotification: opts => dispatch(notify(opts)),
    getCSRF: () => dispatch(getCSRF())
  }
}

export default compose(
  withI18next(['common']),
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers({
    showDuplicateLoginModal: false
  },
  {
    toggleDuplicateLoginModal: () => (value = false) => ({
      showDuplicateLoginModal: value
    })
  }),
  withHandlers({
    terminateCurrentSession: props => () => {
      props.logOut()
      props.toggleDuplicateLoginModal(false)
      Router.push('/')
    },
    terminateOtherSessions: props => () => {
      props.terminateRemoteSessions()
        .then(() => {
          props.toggleDuplicateLoginModal(false)
          props.createNotification({
            type: 'success',
            message: `${props.t('welcome')}, ${props.user.username}`
          })
          Router.push('/')
        })
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.getCSRF()
    },
    componentWillReceiveProps(nextProps) {
      if (nextProps.hasRemoteSessions) {
        nextProps.toggleDuplicateLoginModal(true)
      } else {
        nextProps.toggleDuplicateLoginModal(false)
      }
    }
  }),
  pure
)(AppWrapper)



// WEBPACK FOOTER //
// ./components/AppWrapper/index.js